<template>
  <b-row style="margin-top: 1em">
    <!-- Agent -->
    <b-col cols="12" xl="3">
      <h5 class="text-info">{{ $t("globals.consultant") }}:</h5>
      <b-input-group class="mb-2">
        <b-form-select
          style="max-width: 250px"
          v-model="agent"
          :options="agentOptions"
          :disabled="!getUserBrandPermissions.inquiry_create_master"
        />
        <b-btn variant="danger" @click="deleteTab">
          <icon name="trash-alt"></icon>
        </b-btn>
      </b-input-group>
    </b-col>
    <!-- Duration -->
    <b-col cols="12" sm="6" md="4" lg="3" xl="3">
      <h5 class="text-info">{{ $t("globals.contract") }}:</h5>
      <b-input-group>
        <b-form-select
          style="max-width: 250px"
          v-model="duration"
          :options="durationOptions"
          :disabled="paymentTerm == 0"
        />
        <b-btn variant="danger" @click="reset_duration_period">R</b-btn>
      </b-input-group>
    </b-col>
    <!-- Payment term -->
    <b-col cols="12" sm="6" md="3" lg="3" xl="2">
      <h5 class="text-info">{{ $t("globals.payment_term") }}:</h5>
      <b-form-select
        style="max-width: 250px"
        v-model="paymentTerm"
        :disabled="duration == 0"
        :options="paymentTermOptions"
      />
    </b-col>
    <!-- Payment type -->
    <b-col cols="12" sm="6" md="3" lg="3" xl="2">
      <h5 class="text-info">{{ $t("globals.payment_method") }}:</h5>
      <b-form-select
        style="max-width: 250px"
        v-model="paymentMethod"
        :options="paymentMethodOptions"
      />
    </b-col>
    <!-- Currency -->
    <b-col cols="12" sm="6" md="2" lg="3" xl="2">
      <h5 class="text-info">{{ $t("globals.currency") }}:</h5>
      <b-form-select
        v-model="currency"
        :options="currencyOptions"
        :disabled="getUserSystem !== 'ULU'"
      />
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import "vue-awesome/icons/trash-alt";

export default {
  props: {
    setAgent: Function,
    setDuration: Function,
    setPaymentTerm: Function,
    setPaymentMethod: Function,
    setCurrency: Function,
    deleteTab: Function
  },
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue")
  },
  data() {
    return {
      agent: null,
      duration: 36,
      paymentTerm: 12,
      paymentMethod: "mollie_direct_debit",
      currency: "EUR",
      agentOptions: [],
      durationOptions: [
        { value: 0, text: this.$t("globals.non_applicable") },
        { value: 12, text: "12" + ' ' + this.$t("globals.months")  },
        { value: 24, text: "24" + ' ' + this.$t("globals.months")  },
        { value: 36, text: "36" + ' ' + this.$t("globals.months")  },
        { value: 48, text: "48" + ' ' + this.$t("globals.months")  },
        { value: 60, text: "60" + ' ' + this.$t("globals.months")  }
      ],
      paymentTermOptions: [
        { value: 0, text: this.$t("globals.one_off") },
        { value: 1, text: this.$t("globals.monthly")},
        { value: 3, text: this.$t("globals.quarterly") },
        { value: 6, text: this.$t("globals.half_year") },
        { value: 12, text: this.$t("globals.yearly") }
      ],
      paymentMethodOptions: [
        { text: this.$t("globals.invoice"), value: 'invoice'},
        { text: this.$t("globals.direct_debit_exact"), value: 'direct_debit'},
        { text: this.$t("globals.direct_debit_mollie"), value: 'mollie_direct_debit'}
      ],
      currencyOptions: [
        { value: "EUR", text: "EUR" },
        { value: "GBP", text: "GBP" },
        { value: "USD", text: "USD" }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", { fetchAgentsFromStore: "fetchAgents" }),
    loadAgents() {
      this.fetchAgentsFromStore({ this_ref: this }).then((res) => {
        if (res) {
          this.agentOptions.push(...res);
        }
      });
    },
    reset_duration_period() {
      this.duration = 36;
      this.paymentTerm = 12;
    }
  },
  computed: {
    ...mapGetters([
      "getUserSystem",
      "getUserName",
      "getUserBrandPermissions"
    ])
  },
  watch: {
    agent: function() {
      this.setAgent(this.agent);
    },
    duration: function() {
      this.setDuration(this.duration);
      if (this.duration == 0) {
        this.paymentTerm = 0;
      }
    },
    paymentTerm: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.setPaymentTerm(this.paymentTerm);
        if (newVal == 0) {
          this.duration = 0;
        }
      }
    },
    paymentMethod: function() {
      this.setPaymentMethod(this.paymentMethod);
    },
    currency: function() {
      this.setCurrency(this.currency);
    }
  },
  mounted() {
    this.agentOptions = [{ value: null, text: this.getUserName, active: true }];

    if (this.getUserBrandPermissions.inquiry_create_master) {
      this.loadAgents();
    }

    switch (this.getUserSystem) {
      case "ULU":
        this.currency = "EUR";
        this.paymentMethod = "invoice";
        break;
      case "Cartracker":
        this.currency = "EUR";
        break;
      case "Fleetify":
        this.currency = "GBP";
        break;
      case "uluuk":
        this.currency = "GBP";
        break;
      case "ulubv":
        this.currency = "EUR";
        break;
      case "traksi":
        this.currency = "EUR";
        this.paymentTerm = 1;
        break;
    }
    this.setPaymentTerm(this.paymentTerm);
    this.setDuration(this.duration);
    this.setPaymentMethod(this.paymentMethod);
  }
};
</script>
